import { useState, useEffect } from "react";
import { useGetDocumentByIdQuery } from "../../../redux/apiSlices/Document";
import PdfViewer from "../../../Components/PDF/all-pages";
import { CircularProgress, Typography } from "@mui/material";
type DeliveryNotePdfPreviewerProps = {
  documentId: number;
};

export default function PdfPreviewer({
  documentId,
}: DeliveryNotePdfPreviewerProps) {
  const {
    data: document,
    isLoading,
    isFetching,
    isError,
  } = useGetDocumentByIdQuery(documentId);

  // Only show PDF if we have a valid document with matching ID, handles the case where the document is not found and a previous document is cached
  const shouldShowPdf =
    document &&
    !isLoading &&
    !isFetching &&
    !isError &&
    document.base64 &&
    document.id === documentId;

  return (
    <div className="h-full overflow-auto border rounded-lg flex justify-center">
      {shouldShowPdf ? (
        <PdfViewer
          pdf={
            document?.base64?.startsWith(`data:`)
              ? document
              : `data:application/pdf;base64,${document?.base64}`
          }
        />
      ) : isLoading || isFetching ? (
        <div className="h-full w-full flex justify-center items-center">
          <CircularProgress />
        </div>
      ) : (
        <div className="h-full w-full flex justify-center items-center">
          <Typography variant="h6" color="text.secondary">
            Kein Dokument verfügbar
          </Typography>
        </div>
      )}
    </div>
  );
}
